"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRowHeaderStyles = exports.AvailabilityRowStyles = exports.AvailabilityRowBase = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
exports.AvailabilityRowBase = (0, styled_1.default)(elements_1.Div) `
  display: grid;
  gap: ${constants_1.theme.spacing[3]}px;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
  align-items: center;
  margin: 0;
  min-height: 48px;
  padding-left: ${constants_1.theme.spacing[3]}px;
`;
exports.AvailabilityRowStyles = (0, styled_1.default)(exports.AvailabilityRowBase) `
  border-top: ${constants_1.theme.border.style.thinLight};
  ${({ disabled }) => disabled &&
    `
    background-color: ${constants_1.Color.LIGHT_GREY};
    color: ${constants_1.Color.DARK_MEDIUM_GREY};
  `}
`;
exports.GridRowHeaderStyles = (0, styled_1.default)(exports.AvailabilityRowBase)({
    backgroundColor: constants_1.Color.BACKGROUND_GREY,
});
